import { Button } from "antd";
import styled from "styled-components";
import { color } from "../../resources";

interface IIconButton {
  hover?: boolean;
  color?: string;
  disabled?: boolean;
}

export const IconButton = styled(Button)`
  border-width: 1px;
  background-color: ${(props) => props.color || "#000000"};
  border-color: ${(props: IIconButton) => props.color};
  &:hover {
    border-width: ${(props: IIconButton) => (props.hover ? "1px" : "0px")};
    border-color: ${(props: IIconButton) =>
      props.hover
        ? !props.disabled
          ? color.overlay
          : props.color
        : "transparent"};
    color: ${(props: IIconButton) =>
      props.hover ? props.color : "transparent"};
    background-color: ${(props: IIconButton) =>
      !props.disabled ? props.color : "transparent"} !important;
    opacity: ${(props: IIconButton) =>
      props.hover ? (!props.disabled ? 1 : 0.8) : 1};
  }
`;
